import { render, staticRenderFns } from "./RequestNewMaster.vue?vue&type=template&id=6689f150&"
import script from "./RequestNewMaster.vue?vue&type=script&lang=js&"
export * from "./RequestNewMaster.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports